import React from 'react'
import InboxScreen from '../../../../screens/Conversation/InboxScreen'
import Colors from "../../../../constants/Colors"

export default function Messages() {
	return (
		<InboxScreen color={Colors.redCross.background} />
	)
}